exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-labels-tsx": () => import("./../../../src/pages/labels.tsx" /* webpackChunkName: "component---src-pages-labels-tsx" */),
  "component---src-templates-wine-label-page-template-tsx": () => import("./../../../src/templates/wineLabelPageTemplate.tsx" /* webpackChunkName: "component---src-templates-wine-label-page-template-tsx" */)
}

